import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './LandingPage/Landing';
import Header from './Components/Header/Header';
import Login from './LoginPage/Login';
import LoginCallback from './LoginPage/LoginCallback';
import Home from './HomePage/Home';
import CardBitTool from './KASPage/CardBitTool/CardBitTool';
import KEC from './KECPage/KEC';
import ProtectedRoute from './Components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page route */}
        <Route path="/" element={<Landing />} />
        
        {/* SSO callback route */}
        <Route path="/logincallback" element={<LoginCallback />} />
        
        {/* Protected routes with layout */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <div className="App">
                <Header />
                <div className="app-container">
                  <Login />
                  <main className="main-content">
                    <Home />
                  </main>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/kas/cardbit"
          element={
            <ProtectedRoute>
              <div className="App">
                <Header />
                <div className="app-container">
                  <Login />
                  <main className="main-content">
                    <CardBitTool />
                  </main>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/kec"
          element={
            <ProtectedRoute>
              <div className="App">
                <Header />
                <div className="app-container">
                  <Login />
                  <main className="main-content">
                    <KEC />
                  </main>
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        {/* Redirect any other route to home if authenticated, else to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;